import React from 'react';

import { LazyApplicationNavigatorPage } from '@confluence/site-settings/entry-points/ApplicationNavigatorPage';
import { ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/applicationNavigatorConstants';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminApplicationNavigatorRoute = () => <LazyApplicationNavigatorPage />;

AdminApplicationNavigatorRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
